// get get Subscriber Suscription Product

import { getSubscriberSuscriptionCommProduct } from '../../app/services/CustomerAndProducts/getSubscriberSuscriptionCommProduct'
import { setErrorTextSnackBar, setRequestTextSnackBar } from './app'

export const getSubscriberSuscriptionProduct = (subscriberID) => {
  return async (dispatch) => {
    try {
      const response = await getSubscriberSuscriptionCommProduct(subscriberID)
      return response.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: CustomersAndProductsApi'
          )
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            'Ocurrió un error en un servicio de: ' +
              error.response?.data?.codeMessageLanguage
          )
        )
      }
      return null
    }
  }
}
